'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminUserManagement from './components/AdminUserManagement';

export default function AdminUsersPage() {
  return (
    <AppLayout activePath="/admin/users">
      <AdminUserManagement />
    </AppLayout>
  );
}
